import React from "react";
import { ExpandableLineItems } from "@qgiv/core-donor";
import ConnectedRecurringSummaryHistoryList from "../RecurringSummaryHistoryList";
import "./RecurringSummaryHistoryDetails.scss";

/**
 * @param {object} props
 * @param {string} props.dateLabel
 * @param {string} props.formattedHistoricalTotalCount
 * @param {string} props.historyLabel
 * @param {number} props.numberOfItems
 * @param {string} props.statusLabel
 * @param {number} props.totalDollarValueOfImpact
 * @param {string} props.totalImpactLabel
 * @param {string} props.transactionIdLabel
 * @returns {React.JSX.Element}
 */
const RecurringSummaryHistoryDetails = ({
    dateLabel,
    formattedHistoricalTotalCount,
    historyLabel,
    numberOfItems,
    statusLabel,
    totalDollarValueOfImpact,
    totalImpactLabel,
    transactionIdLabel,
}) => {
    // Tada (🎉) icon which is hardcoded after the customizable totalImpactLabel
    const tadaIcon = <span> &#127881;</span>;
    return (
        <div className="qg-vendor-recurring-summary-history-content col col--12">
            <h3 className="qg-vendor-recurring-summary-history-header -margin-bottom--20">
                {historyLabel}
            </h3>
            <ExpandableLineItems
                numberOfItems={numberOfItems}
                threshold={10}
                showLessLink="Show less"
                showMoreLink="Show more"
            >
                <ConnectedRecurringSummaryHistoryList
                    transactionIdLabel={transactionIdLabel}
                    statusLabel={statusLabel}
                    dateLabel={dateLabel}
                />
            </ExpandableLineItems>
            <div className="qg-vendor-recurring-impact recurring-summary-history-impact -padding-top--20">
                <span className="qg-vendor-recurring-total-impact">
                    <strong>
                        {totalImpactLabel} {tadaIcon}
                    </strong>
                </span>
                <span className="qg-vendor-recurring-impact-amount recurring-impact-amount">
                    <strong>{totalDollarValueOfImpact}</strong>
                    <br />
                    <p className="qg-vendor-recurring-impact-count small">
                        <strong>{formattedHistoricalTotalCount}</strong>
                    </p>
                </span>
            </div>
        </div>
    );
};

export default RecurringSummaryHistoryDetails;
